import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ChartHeader from '@/modules/Statistics/components/ChartHeader.vue';
import ProjectsOverviewField from '@/modules/Statistics/components/ProjectsOverviewField.vue';
import IntroScreenRepository from '@/repositories/IntroScreenRepository';

interface Props {
    isEdit: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsOverview',
  props: {
    isEdit: { type: Boolean }
  },
  setup(__props: any) {



const fields = computed(() => {
    const introScreen = IntroScreenRepository.getFirst();
    if (introScreen == null) {
        return [];
    }

    return introScreen.introScreenItems.sort((a, b) => {
        return a.rowNumber - b.rowNumber;
    });
});

return { __sfc: true,fields, ChartHeader, ProjectsOverviewField }
}

})